<div *ngIf="loginPage">
<div id="sessionExpired" [ngClass]="{'d-block':showSessionExpired,'d-none':!showSessionExpired}"
    class="alert alert-danger" role="alert" >
    <strong> Your session has expired. Please login again.</strong>
</div>
<div class="limiter">
    <div class="bg_img" [ngStyle]="{ 'background': 'url(' + lgnUrl + ')', 'background-repeat': 'no-repeat' }"
        class="container-login100">
        <!-- <div class="container-login100" style="background-image: url('../../../assets/login_bg_no_logo.jpg'); background-repeat: no-repeat;
            background-size: cover;"> -->
        <div style="position: absolute; top:0px; margin: 0px auto;" class="d-none d-md-none d-lg-block" >
            <!-- <img *ngIf="clientName != 'UTTARAKHAND TELEMEDICINE'" [src]="lgnLogo1" class="img-fluid" /> -->
            <!-- <img src="../../../assets/login_logo1.png" class="img-fluid"/> -->
        </div>
        <div class="wrapper">
            <div class="text-center" style="top:0px;  position:absolute;">
            </div>
            <div class="login-page">
                <div class="form m-auto pt-3 pr-5 pl-5">
                    <div class="m-auto pl-5 pr-5 border  border-info shadow-sm rounded-pill loginTitle">
                        <h5 style="font-weight: bold" class="text-info pl-3 pr-3 pt-2 pb-2">
                            User Login
                        </h5>
                    </div>
                    <div class="d-block d-md-block d-lg-none">
                        <div>
                            <img [src]="lgnLogo2" class="img-fluid" />
                            <!-- <img src="../../../assets/login_logo2.png" class="img-fluid"/> -->
                        </div>
                        <h5 style="font-weight: bold" class="text-info pl-3 pr-3 pt-2 pb-2">
                            {{lgnUsrBoxTxt}}
                            <!-- Telehealth Application -->
                        </h5>
                    </div>
                    <!-- <div class="m-auto pl-5 pr-5 border  border-info shadow-sm rounded-pill"
                        style="top: -31px;position: relative;  background: white;">
                        <h5 style="font-weight: bold" class="text-info pl-3 pr-3 pt-2 pb-2">
                            User Login
                        </h5>
                    </div> -->
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form mt-2">
                        <div class="col-12 padingleft input-effect">
                            <input class="effect-16" autocomplete="off" formControlName="username" id="username"
                                maxlength="50" name="username" type="text" (change)="onChngUN()" />
                            <label class="fontsize col-12 padingleft text-left"><i class="fas fa-user"
                                    style="color:#007c78;"></i> Username</label>
                            <span class="focus-border"></span>
                        </div>
                        <div class="col-12 padingleft input-effect mt-4">
                            <input class="effect-16"  formControlName="password" id="password"
                                maxlength="15" name="password"  [type]="showPassword ? 'text' : 'password'"  (change)="onChngPassword()"/>
                                <div  style="position: absolute ;
                                right: 0px;
                                top: 0;">
                                    <i alt="show" class="far fa-eye eye-show"  style="color: #00cfd5 !important;"
                                    (click)="showPassword = !showPassword"
                                    [class.hide]="showPassword"></i>
                                    <i alt="hide" class="far fa-eye-slash eye-hide"  style="color: #00cfd5 !important;"
                                    (click)="showPassword = !showPassword"
                                    [class.hide]="!showPassword"></i>
                                  </div>
                                  <!-- <div 
                                  (mousedown)="showPasswordOnPress = !showPasswordOnPress" 
                                  (mouseup)="showPasswordOnPress = !showPasswordOnPress">
                                    <i alt="show" class="fas fa-eye eye-show" 
                                    
                                    [class.hide]="showPasswordOnPress"></i>
                                    <i alt="hide" class="fas fa-eye-slash eye-hide" 
                                    
                                    [class.hide]="!showPasswordOnPress"></i>
                                  </div> -->
                            <label class="fontsize col-12 padingleft text-left"><i class="fas fa-key"
                                    style="color:#007c78;"></i> Password</label>
                            <span class="focus-border"></span>
                        </div>
                        <div class="col-12 padingleft input-effect mt-4">
                            <div class="card">
                                <img [src]="captChaImg" class="card-img-top" alt="Fissure in Sandstone"/><span (click)="callCaptchaAPI()" onmouseover=""  style="color:#007c78;cursor: pointer;">Refresh</span>
                              </div>
                       </div>
                       <br>
                        <div class="col-12 padingleft input-effect">
                            <input class="effect-16" autocomplete="off" formControlName="captchaText" id="captchaText"
                               name="captchaText" type="text" (change)="onChngCapthaImg()" />
                            <label class="fontsize col-12 padingleft text-left">Captcha Image Text</label>
                            <span class="focus-border"></span>
                        </div>
                        <div class="row mt-4 mb-2">
                            <div class="col-12 col-lg-12 col-12">
                                <button type="submit" class="btn btn-lg btn-primary active  p-1 pt-2"
                                    style="background-color:#a0530b;"> <span
                                        style="text-transform: capitalize; font-size: 18px">Login</span></button>
                            </div>
                            <!-- <div class="col-12 col-lg-8 col-8 mt-3"><a class="float-left forgo" > Forgot Password? </a></div> -->
                        </div>
                    </form>
                    <div class="d-block d-md-block d-lg-none">
                        <h6 class="text-dark">For Support, Please contact {{clientName}}</h6>
                        <div class="text-center text-dark"><a (click)="onTollFree()">
                                <i class="fa fa-phone text-dark" aria-hidden="true"></i>&nbsp;&nbsp;{{tollFree}}</a>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-6 col-lg-6 small mb-1 text-left">
                            <a class="text-info pointer" style="font-size: 12px;"
                                (click)="forgotpaasword()"><i class="fa fa-key"></i> <strong> Forgot Password</strong></a>
                        </div>
                        <div class="col-6 col-lg-6 small mb-1">
                            <div class="form-check-inline">
                                <label class="form-check-label pointer">
                                    <input type="checkbox" class="form-check-input chk" [checked]="isRmbrChk"
                                        (change)="isRmbrChk=!isRmbrChk"><strong>Remember me</strong>
                                </label>
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-12 col-lg-7 small mb-1 text-xl-left pl-0 pr-0">
                            <a class="text-info pointer" style="font-size: 12px;" (click)="forgotpaasword()"><i
                                    class="fa fa-key"></i> <strong> Forgot Password</strong></a>
                        </div>
                        <div class="col-12 col-lg-5 small text-xl-right pl-0 pr-0">
                            <div>
                                <label class="pointer chk2"><input type="checkbox" style="width: auto !important;"
                                        [checked]="isRmbrChk" (change)="isRmbrChk=!isRmbrChk" /> <strong> Remember
                                        me</strong>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- About Us & About Content links -->
                    <div class="row mt-2" *ngIf="isTenant81">
                        <div class="col-6 small text-left pl-0 pr-0">
                            <a class="text-info pointer about-link" style="font-size: 12px;" (click)="toggleAboutInfo()">
                                <i class="fa fa-info-circle"></i> <strong> About Us</strong>
                            </a>
                        </div>
                        <!-- <div class="col-6 small text-right pl-0 pr-0">
                            <a class="text-info pointer about-link" style="font-size: 12px;" (click)="toggleAboutContent()">
                                <i class="fa fa-file-alt"></i> <strong> About Content</strong>
                            </a>
                        </div> -->
                    </div>
                    <!-- <div class="row">
                        <div class="col-12 col-lg-7 small mb-1 text-xl-left pl-0 pr-0"></div>
                            <div class="col-12 col-lg-5 small mb-1 text-xl-left pl-0 pr-0">
                            <a class="text-info pointer" style="font-size: 12px;" routerLink="/home/rakthadhan/rakthadhanReg"><strong>Register Here!</strong></a>
                        </div>
                    </div> -->
                    <div class="d-none d-md-none d-lg-block">
                        <p class="text-center text-white small" style="position: relative; top: 45px;">Powered by
                            {{pwrdBy}}<br>
                           <span *ngIf="isNIG">&copy;All rights reserved to {{pwrdBy}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-none d-md-none d-lg-block">
    <div class="support ">
        <h6>For Support, Please contact {{clientName}}</h6>
        <div class="text-right"><a class="btn btn-info" (click)="onTollFree()">
                <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;{{tollFree}}</a>
        </div>
    </div>
</div>

<!-- About Us Side Panel (iframe) -->
<div class="about-overlay" [class.active]="showAboutUs || showAboutContent || showAboutInfo" (click)="closeAboutPanels()"></div>

<!-- About Us – iframe panel -->
<div class="about-side-panel" [class.open]="showAboutUs">
    <div class="about-panel-header">
        <span><i class="fa fa-info-circle mr-2"></i><strong>About Us</strong></span>
        <button class="about-close-btn" (click)="closeAboutPanels()">&times;</button>
    </div>
    <div class="about-panel-body">
        <iframe *ngIf="showAboutUs"
            src="https://chattisgarah.ccad.org.in/our-services/"
            frameborder="0"
            width="100%"
            height="100%"
            title="About Us">
        </iframe>
    </div>
</div>

<!-- About Us – Infographic panel -->
<div class="about-side-panel aip-panel" [class.open]="showAboutInfo">
    <div class="about-panel-header">
        <div class="aip-header-left">
            <i class="fa fa-ambulance mr-2"></i>
            <div>
                <div class="aip-header-org">Mobile Medical Unit</div>
                <div class="aip-header-sub">Government of Chhattisgarh</div>
            </div>
        </div>
        <button class="about-close-btn" (click)="closeAboutPanels()">&times;</button>
    </div>
    <div class="about-panel-body aip-body">

        <!-- ── HERO: text left, image right ── -->
        <div class="aip-hero2">
            <div class="aip-hero2-text">
                <!-- <div class="aip-about-badge2">— About Us</div> -->
                <h2 class="aip-hero2-title">Chhattisgarh<br><span>Mobile Medical Unit</span></h2>
                <p class="aip-hero2-sub">Bringing Healthcare Closer to Every Community</p>
                <p class="aip-hero2-desc">Mobile Medical Units (MMUs) are fully equipped medical vans that deliver
                    quality primary healthcare services to the remotest and underserved areas of Chhattisgarh.</p>
            </div>
            <div class="aip-hero2-img-wrap">
                <img *ngFor="let img of mmuHeroImages; let i = index"
                     [src]="img.src" [alt]="img.alt"
                     class="aip-hero2-img"
                     [class.active]="heroSlide === i" />
                <div class="aip-hero2-dots">
                    <span *ngFor="let img of mmuHeroImages; let i = index"
                          class="aip-dot2" [class.active]="heroSlide === i"
                          (click)="heroSlide = i"></span>
                </div>
            </div>
        </div>

        <!-- ── TEAL STATS BAR ── -->
        <div class="aip-teal-bar">
            <div class="aip-teal-stat">
                <i class="fa fa-heartbeat"></i>
                <div>
                    <strong>Reaching the Unreached</strong>
                    <p>Healthcare services in remote and tribal areas</p>
                </div>
            </div>
            <div class="aip-teal-stat">
                <i class="fa fa-users"></i>
                <div>
                    <strong>Community Centric</strong>
                    <p>Focused on preventive, promotive &amp; curative care</p>
                </div>
            </div>
            <div class="aip-teal-stat">
                <i class="fa fa-plus-circle"></i>
                <div>
                    <strong>Quality Care Assured</strong>
                    <p>Trained professionals with modern medical equipment</p>
                </div>
            </div>
            <div class="aip-teal-stat">
                <i class="fa fa-leaf"></i>
                <div>
                    <strong>Healthy Chhattisgarh</strong>
                    <p>Building stronger, healthier communities together</p>
                </div>
            </div>
        </div>

        <!-- ── OUR IMPACT + SERVING ACROSS CHHATTISGARH ── -->
        <div class="aip-impact-row">
            <!-- Impact numbers -->
            <div class="aip-impact-card">
                <h5 class="aip-card-title2">Our Impact</h5>
                <div class="aip-impact-grid">
                    <div class="aip-impact-item">
                        <i class="fa fa-users"></i>
                        <strong>1.2+ Million</strong>
                        <span>Beneficiaries</span>
                    </div>
                    <div class="aip-impact-item">
                        <i class="fa fa-stethoscope"></i>
                        <strong>85,000+</strong>
                        <span>OPD Consultations</span>
                    </div>
                    <div class="aip-impact-item">
                        <i class="fa fa-clipboard-list"></i>
                        <strong>250+</strong>
                        <span>Mobile Medical Units</span>
                    </div>
                    <div class="aip-impact-item">
                        <i class="fa fa-map-marker-alt"></i>
                        <strong>3000+</strong>
                        <span>Villages Covered</span>
                    </div>
                    <div class="aip-impact-item">
                        <i class="fa fa-user-md"></i>
                        <strong>500+</strong>
                        <span>Healthcare Professionals</span>
                    </div>
                    <div class="aip-impact-item">
                        <i class="fa fa-pills"></i>
                        <strong>Free</strong>
                        <span>Essential Medicines Provided</span>
                    </div>
                </div>
                <p class="aip-data-note">*Data is indicative and updated periodically.</p>
            </div>

            <!-- Map / district images -->
            <div class="aip-map-card">
                <h5 class="aip-card-title2">Serving Across Chhattisgarh</h5>
                <p class="aip-map-desc">Delivering healthcare to every corner of the state, with a special focus on
                    tribal and remote regions.</p>
                <div class="aip-map-img-wrap">
                    <img *ngFor="let img of mmuMapImages; let i = index"
                         [src]="img.src" [alt]="img.alt"
                         class="aip-map-img"
                         [class.active]="mapSlide === i" />
                </div>
                <div class="aip-map-legend">
                    <span class="aip-legend-dot" style="background:#a8d8a8;"></span> North Chhattisgarh
                    <span class="aip-legend-dot ml-2" style="background:#f9c784;"></span> Central Chhattisgarh
                    <span class="aip-legend-dot ml-2" style="background:#f4a261;"></span> South Chhattisgarh
                    <span class="aip-legend-dot ml-2" style="background:#e76f51;"></span> Tribal Dominated Areas
                </div>
            </div>
        </div>

        <!-- ── OUR SERVICES + IMAGE WITH QUOTE ── -->
        <div class="aip-svc-row">
            <!-- Services grid -->
            <div class="aip-svc-card">
                <h5 class="aip-card-title2">Our Services</h5>
                <div class="aip-svc-grid2">
                    <div class="aip-svc2"><i class="fa fa-stethoscope"></i><span>General OPD Services</span></div>
                    <div class="aip-svc2"><i class="fa fa-baby"></i><span>Maternal &amp; Child Health</span></div>
                    <div class="aip-svc2"><i class="fa fa-syringe"></i><span>Immunization Services</span></div>
                    <div class="aip-svc2"><i class="fa fa-heartbeat"></i><span>NCD Screening &amp; Management</span></div>
                    <div class="aip-svc2"><i class="fa fa-flask"></i><span>Laboratory Tests</span></div>
                    <div class="aip-svc2"><i class="fa fa-pills"></i><span>Essential Medicines</span></div>
                    <div class="aip-svc2"><i class="fa fa-bullhorn"></i><span>Health Education &amp; Counseling</span></div>
                    <div class="aip-svc2"><i class="fa fa-shield-virus"></i><span>Disease Prevention &amp; Control</span></div>
                </div>
            </div>

            <!-- MMU image with quote overlay -->
            <div class="aip-quote-img-wrap">
                <img *ngFor="let img of mmuQuoteImages; let i = index"
                     [src]="img.src" [alt]="img.alt"
                     class="aip-quote-img"
                     [class.active]="quoteSlide === i" />
                <div class="aip-quote-overlay">
                    <i class="fa fa-quote-left"></i>
                    <p>Our mission is simple – to ensure that no one is left behind when it comes to healthcare.</p>
                </div>
            </div>
        </div>

        <!-- ── FOOTER ── -->
        <div class="aip-footer2">
            <i class="fa fa-ambulance"></i>
            <div>
                <strong>Building a Healthier Chhattisgarh</strong>
                <p>Together, we can create a healthier and stronger tomorrow for every family.</p>
            </div>
        </div>

    </div>
</div>

<!-- About Content Side Panel (HTML content) -->
<div class="about-side-panel" [class.open]="showAboutContent">
    <div class="about-panel-header">
        <span><i class="fa fa-file-alt mr-2"></i><strong>About Content</strong></span>
        <button class="about-close-btn" (click)="closeAboutPanels()">&times;</button>
    </div>
    <div class="about-panel-body about-html-content">
        <div class="about-content-inner">

            <!-- ── IMAGE STRIP ── -->
            <div class="ac-img-strip-wrap">
                <div class="ac-img-strip" id="mmuImgStrip"
                     (mouseenter)="pauseAutoScroll()"
                     (mouseleave)="resumeAutoScroll()">
                    <!-- doubled list for seamless infinite loop -->
                    <div class="ac-img-thumb" *ngFor="let img of mmuImagesLoop; let i = index"
                         (click)="openLightbox(i % mmuImages.length)">
                        <img [src]="img.src" [alt]="img.alt" />
                        <div class="ac-img-overlay"><i class="fa fa-search-plus"></i></div>
                    </div>
                </div>
            </div>

            <!-- ── LIGHTBOX ── -->
            <div class="ac-lightbox" *ngIf="lightboxIndex !== null" (click)="closeLightbox()">
                <div class="ac-lightbox-inner" (click)="$event.stopPropagation()">
                    <button class="ac-lb-close" (click)="closeLightbox()">&times;</button>
                    <button class="ac-lb-prev" (click)="prevImage()" [disabled]="lightboxIndex === 0">&#8249;</button>
                    <img [src]="mmuImages[lightboxIndex].src" [alt]="mmuImages[lightboxIndex].alt" class="ac-lb-img" />
                    <button class="ac-lb-next" (click)="nextImage()" [disabled]="lightboxIndex === mmuImages.length - 1">&#8250;</button>
                    <div class="ac-lb-counter">{{ lightboxIndex + 1 }} / {{ mmuImages.length }}</div>
                </div>
            </div>

            <!-- ── HERO SECTION ── -->
            <div class="ac-hero">
                <h2 style="color: white;">Chhattisgarh Mobile Medical Unit</h2>
                <p>In the remote and underserved regions of Chhattisgarh, access to timely healthcare remains a
                    challenge. Mobile Medical Units (MMUs) bridge this gap by delivering quality primary healthcare
                    services directly to communities.</p>
                <p>Fully equipped medical vans with trained healthcare professionals provide preventive, promotive,
                    and curative services across rural and tribal areas.</p>
            </div>

            <!-- ── INTRODUCTION ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Introduction</h4>
                <h5 class="ac-subheading">Transforming Last-Mile Healthcare Access: Mobile Medical Units under PM-JANMAN in Chhattisgarh</h5>
                <p>India has made notable progress in strengthening its public health system; however, disparities in
                    healthcare access continue to persist, particularly in remote, forested, and tribal regions. In
                    Chhattisgarh, about <strong>32.6%</strong> of the population belongs to Scheduled Tribes, making it
                    one of the most tribal-dominated states in the country.</p>
                <p>A large proportion of these communities reside in hard-to-reach, forested, and Left Wing
                    Extremism (LWE)-affected areas, characterized by poor connectivity, scattered habitations, and
                    limited healthcare infrastructure.</p>
                <p>Although Sub-Centres, Primary Health Centres (PHCs), and Community Health Centres (CHCs) have
                    been established, challenges such as difficult terrain, shortage of healthcare professionals, and
                    transport constraints continue to hinder timely access to healthcare services.</p>
                <p>To address these structural challenges, the Government of India launched the <strong>Pradhan
                    Mantri Janjati Adivasi Nyaya Maha Abhiyan (PM-JANMAN)</strong>, with a focused mandate to improve
                    healthcare access for Particularly Vulnerable Tribal Groups (PVTGs). Under this initiative,
                    <strong>Mobile Medical Units (MMUs)</strong> have been introduced as a key service delivery model
                    to bridge last-mile gaps.</p>
            </div>

            <!-- ── MMU OPERATIONS ── -->
            <div class="ac-section">
                <h4 class="ac-heading">MMU Operations in Chhattisgarh</h4>
                <h5 class="ac-subheading">Program Overview</h5>
                <p>Currently, <strong>57 Mobile Medical Units (MMUs)</strong> are operational under the PM-JANMAN
                    initiative in Chhattisgarh, strategically deployed across <strong>18 districts</strong> to ensure
                    last-mile healthcare delivery to tribal and underserved populations.</p>

                <h5 class="ac-subheading mt-3">District Deployment</h5>
                <div class="ac-table-wrap">
                    <table class="ac-table">
                        <thead>
                            <tr><th>S.No.</th><th>Name of Districts</th><th>No. of Operational MMUs</th></tr>
                        </thead>
                        <tbody>
                            <tr><td>1</td><td>Balodabazar</td><td>1</td></tr>
                            <tr><td>2</td><td>Balrampur</td><td>4</td></tr>
                            <tr><td>3</td><td>Bilaspur</td><td>3</td></tr>
                            <tr><td>4</td><td>Dhamtari</td><td>3</td></tr>
                            <tr><td>5</td><td>Gariyaband</td><td>4</td></tr>
                            <tr><td>6</td><td>GPM</td><td>3</td></tr>
                            <tr><td>7</td><td>Jashpur</td><td>6</td></tr>
                            <tr><td>8</td><td>Kabeerdham</td><td>3</td></tr>
                            <tr><td>9</td><td>Kanker</td><td>3</td></tr>
                            <tr><td>10</td><td>KCG</td><td>2</td></tr>
                            <tr><td>11</td><td>Kondagaon</td><td>1</td></tr>
                            <tr><td>12</td><td>Korba</td><td>4</td></tr>
                            <tr><td>13</td><td>Mahasamund</td><td>3</td></tr>
                            <tr><td>14</td><td>MCB</td><td>3</td></tr>
                            <tr><td>15</td><td>Mungeli</td><td>1</td></tr>
                            <tr><td>16</td><td>Narayanpur</td><td>2</td></tr>
                            <tr><td>17</td><td>Raigarh</td><td>4</td></tr>
                            <tr><td>18</td><td>Surguja</td><td>7</td></tr>
                        </tbody>
                    </table>
                </div>

                <h5 class="ac-subheading mt-3">Team &amp; Infrastructure</h5>
                <p>Each MMU is staffed with a dedicated multidisciplinary team comprising:</p>
                <ul>
                    <li>1 MBBS Doctor (Medical Officer)</li>
                    <li>1 Nurse / ANM</li>
                    <li>1 Laboratory Technician</li>
                    <li>1 Driver-cum-support staff</li>
                </ul>
                <p>MMUs follow pre-approved, rotational routes to cover targeted villages on specific days, ensuring
                    periodic and consistent outreach. <strong>All services are provided free of cost</strong> to
                    beneficiaries.</p>
            </div>

            <!-- ── OUR SERVICES ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Our Services: Comprehensive Clinical Care</h4>

                <div class="ac-service-grid">
                    <div class="ac-service-card">
                        <h6><i class="fa fa-stethoscope"></i> Clinical Services</h6>
                        <ul>
                            <li>General OPD consultations</li>
                            <li>Treatment of common illnesses and infections</li>
                            <li>Minor procedures and first aid</li>
                            <li>Chronic disease management</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-baby"></i> Maternal &amp; Child Health</h6>
                        <ul>
                            <li>Antenatal and postnatal care</li>
                            <li>High-risk pregnancy identification</li>
                            <li>Child health screening and immunization support</li>
                            <li>Nutrition counselling</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-virus"></i> Communicable Disease Management</h6>
                        <ul>
                            <li>Malaria, dengue screening and treatment</li>
                            <li>TB screening and sputum collection</li>
                            <li>Leprosy identification and referral</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-heartbeat"></i> Non-Communicable Diseases</h6>
                        <ul>
                            <li>Screening for hypertension and diabetes</li>
                            <li>Cancer screening (oral, breast, cervical)</li>
                            <li>Sickle cell disease screening and counselling</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-flask"></i> Diagnostic Services (On-Board Lab)</h6>
                        <ul>
                            <li>Hemoglobin (Hb), Blood sugar, LFT, RFT, Lipid profile</li>
                            <li>Complete Blood Count (CBC), VDRL</li>
                            <li>Urine sugar and albumin</li>
                            <li>Point-of-care: Malaria, Dengue, HIV, Sickle cell, Pregnancy tests</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-pills"></i> Free Medicine Distribution</h6>
                        <ul>
                            <li>Essential medicines for acute illnesses</li>
                            <li>Medication for chronic diseases</li>
                            <li>Monthly drug support</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-bullhorn"></i> Public Health Services</h6>
                        <ul>
                            <li>Health awareness and IEC activities</li>
                            <li>Hygiene and nutrition education</li>
                            <li>Lifestyle counselling</li>
                        </ul>
                    </div>
                    <div class="ac-service-card">
                        <h6><i class="fa fa-ambulance"></i> Emergency &amp; Referral Services</h6>
                        <ul>
                            <li>Basic life support</li>
                            <li>Stabilization of patients</li>
                            <li>Referral to PHC / CHC / District Hospitals</li>
                            <li>Linkage with emergency transport</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- ── KEY BENEFITS ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Key Benefits of MMUs</h4>
                <div class="ac-benefits">
                    <div class="ac-benefit-item">✅ <strong>Accessible Healthcare</strong> – Doorstep doctor consultations in remote and tribal areas.</div>
                    <div class="ac-benefit-item">✅ <strong>Free Medicines</strong> – On-the-spot distribution of essential medicines.</div>
                    <div class="ac-benefit-item">✅ <strong>Health Monitoring</strong> – Regular screening of basic health indicators.</div>
                    <div class="ac-benefit-item">✅ <strong>Health Awareness</strong> – Guidance on maternal health, nutrition, and hygiene.</div>
                </div>
            </div>

            <!-- ── WHY MMUs MATTER ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Why Mobile Medical Units (MMUs) Matter</h4>
                <div class="ac-benefits">
                    <div class="ac-benefit-item">✅ <strong>Providing Timely Medical Care</strong> – Enabling early diagnosis and treatment at the community level.</div>
                    <div class="ac-benefit-item">✅ <strong>Reducing Financial Burden</strong> – Offering free doorstep services, minimizing travel costs and out-of-pocket expenditure.</div>
                    <div class="ac-benefit-item">✅ <strong>Enhancing Health Awareness</strong> – Promoting preventive healthcare, hygiene, nutrition, and early health-seeking behavior.</div>
                    <div class="ac-benefit-item">✅ <strong>Strengthening Public Health Systems</strong> – Acting as an extension of government health programs.</div>
                    <div class="ac-benefit-item">✅ <strong>Ensuring Comprehensive Care</strong> – Delivering an integrated package including consultations, diagnostics, medicines, and referral linkages.</div>
                </div>
            </div>

            <!-- ── ABOUT CHHATTISGARH ── -->
            <div class="ac-section">
                <h4 class="ac-heading">About Chhattisgarh – Mobile Medical Units (MMUs)</h4>
                <p>Despite progress in healthcare, remote and tribal regions in Chhattisgarh continue to face
                    challenges due to difficult terrain, scattered habitations, and limited access to health
                    facilities. The MMU program under <strong>PM-JANMAN</strong> acts as a last-mile healthcare
                    solution, delivering services directly to communities.</p>

                <h5 class="ac-subheading mt-3">Objectives</h5>
                <ul>
                    <li>Improve access to primary healthcare services</li>
                    <li>Enable early detection and management of diseases</li>
                    <li>Reduce out-of-pocket healthcare expenses</li>
                    <li>Strengthen community-level health awareness</li>
                </ul>

                <h5 class="ac-subheading mt-3">How It Works</h5>
                <div class="ac-steps">
                    <div class="ac-step"><span class="ac-step-num">1</span><div><strong>Scheduled Visits</strong><br>MMUs follow fixed routes covering identified villages and habitations.</div></div>
                    <div class="ac-step"><span class="ac-step-num">2</span><div><strong>Community Mobilization</strong><br>Local health workers inform communities in advance.</div></div>
                    <div class="ac-step"><span class="ac-step-num">3</span><div><strong>On-site Service Delivery</strong><br>Consultations, diagnostics, and medicines are provided at the location.</div></div>
                    <div class="ac-step"><span class="ac-step-num">4</span><div><strong>Follow-up &amp; Referral</strong><br>Patients requiring advanced care are referred to higher facilities.</div></div>
                </div>
            </div>

            <!-- ── KEY OBJECTIVES ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Key Objectives of MMUs in Chhattisgarh</h4>
                <ol class="ac-ol">
                    <li><strong>Enhance Access to Healthcare:</strong> Deliver primary healthcare services at the doorstep of remote and underserved communities.</li>
                    <li><strong>Reach Vulnerable Populations:</strong> Focus on tribal and marginalized groups with limited access to health facilities.</li>
                    <li><strong>Comprehensive Healthcare Delivery:</strong> Provide preventive, promotive and curative services including check-ups, treatment, and referrals.</li>
                    <li><strong>Early Disease Detection:</strong> Screen and manage communicable and non-communicable diseases using point-of-care diagnostics.</li>
                    <li><strong>Timely Referrals:</strong> Ensure appropriate referral of serious cases to higher healthcare facilities.</li>
                    <li><strong>Improve Health-Seeking Behavior:</strong> Encourage communities to seek timely and regular healthcare services.</li>
                    <li><strong>Health Awareness &amp; Education:</strong> Promote hygiene, nutrition, and public health practices through IEC/BCC activities.</li>
                    <li><strong>Digitize Health Services:</strong> Maintain electronic health records for monitoring and better decision-making.</li>
                    <li><strong>Support Government Programs:</strong> Strengthen outreach of national and state health initiatives at the community level.</li>
                    <li><strong>Ensure Quality Standards:</strong> Deliver standardized services as per defined technical and operational protocols.</li>
                </ol>
            </div>

            <!-- ── CHALLENGES ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Challenges Addressed by MMUs in Chhattisgarh</h4>
                <div class="ac-challenges">
                    <div class="ac-challenge-item">
                        <i class="fa fa-road ac-challenge-icon"></i>
                        <div><strong>Difficult Terrain &amp; Limited Connectivity</strong> – Many tribal and forested areas have poor road access. MMUs bridge this gap by delivering healthcare directly to remote communities.</div>
                    </div>
                    <div class="ac-challenge-item">
                        <i class="fa fa-money-bill-wave ac-challenge-icon"></i>
                        <div><strong>High Out-of-Pocket Expenses</strong> – Traveling long distances to district hospitals is costly. MMUs provide free consultations, diagnostics, and medicines.</div>
                    </div>
                    <div class="ac-challenge-item">
                        <i class="fa fa-hospital ac-challenge-icon"></i>
                        <div><strong>Limited Healthcare Infrastructure</strong> – Shortage of doctors and functional health facilities leads to delayed care. MMUs ensure regular availability of primary healthcare at the doorstep.</div>
                    </div>
                    <div class="ac-challenge-item">
                        <i class="fa fa-graduation-cap ac-challenge-icon"></i>
                        <div><strong>Low Health Awareness</strong> – Limited awareness on preventive care, nutrition, and NCDs contributes to disease burden. MMUs actively conduct IEC/BCC activities.</div>
                    </div>
                </div>
            </div>

            <!-- ── VISION & MISSION ── -->
            <div class="ac-section">
                <div class="ac-vm-grid">
                    <div class="ac-vm-card ac-vision">
                        <h5><i class="fa fa-eye mr-2"></i>Vision</h5>
                        <p>"To establish Mobile Medical Units (MMUs) as integrated, last-mile healthcare delivery
                            platforms that ensure equitable, reliable, and quality health services for remote, tribal,
                            and underserved populations of Chhattisgarh."</p>
                    </div>
                    <div class="ac-vm-card ac-mission">
                        <h5><i class="fa fa-bullseye mr-2"></i>Mission</h5>
                        <p>"To deploy and operationalize a network of well-equipped Mobile Medical Units (MMUs) that
                            function as decentralized healthcare delivery hubs, providing comprehensive preventive,
                            promotive, diagnostic, and curative services at the doorstep of PVTGs and underserved
                            communities, while strengthening referral linkages and integration with the public health
                            system."</p>
                    </div>
                </div>
            </div>

            <!-- ── NATURE OF SERVICES ── -->
            <div class="ac-section">
                <h4 class="ac-heading">Nature of Services</h4>
                <div class="ac-nature-grid">
                    <div class="ac-nature-card">
                        <h6>1. Primary Healthcare (OPD Services)</h6>
                        <ul><li>General OPD consultation for common illnesses</li><li>Treatment of fever, infections, minor injuries</li><li>Basic curative care at doorstep</li><li>MMU acts like a "moving PHC"</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>2. Screening &amp; Early Diagnosis</h6>
                        <ul><li>Hypertension, Diabetes, Cancer (oral, breast, cervical)</li><li>Early identification of diseases</li><li>Regular follow-up visits</li><li>Focus on preventive healthcare &amp; early detection</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>3. Basic Diagnostics (Point-of-Care Tests)</h6>
                        <ul><li>Blood glucose, Hemoglobin (Hb), Urine tests</li><li>Pregnancy tests, Malaria / RDT tests</li><li>Height, weight, BMI</li><li>On-the-spot diagnostics available in MMU vans</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>4. Free Medicines Distribution</h6>
                        <ul><li>Fever, infections, BP, diabetes, chronic diseases</li><li>Monthly drug supply for chronic patients</li><li>Medicines provided free of cost</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>5. Maternal &amp; Child Health (RMNCH+A)</h6>
                        <ul><li>Antenatal &amp; postnatal care</li><li>Child health check-ups</li><li>Immunization support</li><li>Nutrition counselling</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>6. NCD Management</h6>
                        <ul><li>Hypertension, diabetes, epilepsy</li><li>Lifestyle disease management</li><li>Regular monitoring &amp; follow-up</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>7. Communicable Disease Management</h6>
                        <ul><li>TB screening (sputum collection)</li><li>Malaria, dengue, infections</li><li>Fever surveillance</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>8. Mental Health Services</h6>
                        <ul><li>Basic counselling</li><li>Identification of mental illness</li><li>Referral to higher centres</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>9. Specialized Services</h6>
                        <ul><li>Eye care (vision testing)</li><li>ENT services</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>10. Emergency &amp; First Aid Services</h6>
                        <ul><li>Basic life support</li><li>Stabilization of patients</li><li>Referral transport coordination</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>11. Referral Services</h6>
                        <ul><li>Referral to PHC / CHC / District hospital</li><li>Linkage with 108 ambulance services</li><li>MMU ensures continuum of care</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>12. Health Awareness &amp; IEC Activities</h6>
                        <ul><li>Health education sessions</li><li>Awareness on hygiene, nutrition, family planning, NCD prevention</li><li>Promotes preventive &amp; promotive health behavior</li></ul>
                    </div>
                    <div class="ac-nature-card">
                        <h6>13. Outreach to Remote &amp; Tribal Areas</h6>
                        <ul><li>Doorstep healthcare delivery</li><li>Coverage of remote villages, tribal areas, underserved populations</li><li>Core objective: reach unreached population</li></ul>
                    </div>
                </div>
            </div>

            <!-- ── MMU REACH ── -->
            <div class="ac-section">
                <h4 class="ac-heading">MMU Reach – District-wise Operations</h4>
                <p>Currently, <strong>57 Mobile Medical Units (MMUs)</strong> are operational under the PM-JANMAN
                    initiative in Chhattisgarh, strategically deployed across <strong>18 districts</strong>.</p>
                <div class="ac-table-wrap">
                    <table class="ac-table">
                        <thead>
                            <tr><th>S.No.</th><th>Name of Districts</th><th>No. of Operational MMUs</th></tr>
                        </thead>
                        <tbody>
                            <tr><td>1</td><td>Balodabazar</td><td>1</td></tr>
                            <tr><td>2</td><td>Balrampur</td><td>4</td></tr>
                            <tr><td>3</td><td>Bilaspur</td><td>3</td></tr>
                            <tr><td>4</td><td>Dhamtari</td><td>3</td></tr>
                            <tr><td>5</td><td>Gariyaband</td><td>4</td></tr>
                            <tr><td>6</td><td>GPM</td><td>3</td></tr>
                            <tr><td>7</td><td>Jashpur</td><td>6</td></tr>
                            <tr><td>8</td><td>Kabeerdham</td><td>3</td></tr>
                            <tr><td>9</td><td>Kanker</td><td>3</td></tr>
                            <tr><td>10</td><td>KCG</td><td>2</td></tr>
                            <tr><td>11</td><td>Kondagaon</td><td>1</td></tr>
                            <tr><td>12</td><td>Korba</td><td>4</td></tr>
                            <tr><td>13</td><td>Mahasamund</td><td>3</td></tr>
                            <tr><td>14</td><td>MCB</td><td>3</td></tr>
                            <tr><td>15</td><td>Mungeli</td><td>1</td></tr>
                            <tr><td>16</td><td>Narayanpur</td><td>2</td></tr>
                            <tr><td>17</td><td>Raigarh</td><td>4</td></tr>
                            <tr><td>18</td><td>Surguja</td><td>7</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- ── CHHATTISGARH MMU PROGRAM ── -->
            <div class="ac-section ac-footer-section">
                <h4 class="ac-heading">Chhattisgarh MMU Program</h4>
                <p>In Chhattisgarh, where a significant population resides in tribal, forested, and geographically
                    remote regions, MMUs are crucial in addressing persistent healthcare access gaps. Under
                    <strong>PM-JANMAN</strong>, MMUs are strategically deployed to deliver doorstep healthcare
                    services to the most remote villages and hamlets.</p>
                <p>By combining trained medical teams, diagnostic capabilities, and digital health systems, MMUs
                    ensure that essential healthcare services reach the last mile — advancing the state's commitment
                    to equitable healthcare and <strong>Universal Health Coverage (UHC)</strong>.</p>
                <p class="ac-tagline">"Mobile Medical Unit is a clinic on wheels delivering primary healthcare,
                    diagnostics, medicines, and preventive services at the doorstep of rural and underserved
                    populations."</p>
            </div>

        </div>
    </div>
</div>

<!-- Confirm Message for Same user login -->
<button type="button" class="d-none" data-toggle="modal" data-target="#logInConfirmMessage"
    id="btnLogInConfirmMessage"></button>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="logInConfirmMessage" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Login Confirmation</h5>
                <button type="button" id="btnLogInConfirmMessageClose" class="close" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body alert alert-danger" role="alert">
                <!-- <div class="alert alert-danger" role="alert"> -->
                    Another user with the same username <strong>({{current_userName}})</strong> is already logged in to
                    application.<strong>Do you want to continue?</strong>
                <!-- </div> -->
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal"
                    (click)="checkYes()" id="bypassLgn">Yes</button>
                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>

<!-- <div class="col-md-6 offset-md-3 mt-5">
    <div class="card">
        <h4 class="card-header">
            Angular 8 JWT Login Example<br />
            apiCalled: {{apiCalled}} <br />
            submit clicked: {{loginCalled}}
        </h4>
        <div class="card-body">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" formControlName="username" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.username.errors }" autocomplete="off" />
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">Username is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" formControlName="password" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                </div>
                <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Login
                </button>
                <button class="btn btn-primary" #loginButton>Login</button>
                <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
            </form>
        </div>
    </div>
</div> -->

</div>